











































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Browser extends Vue {
  url = "";
  urlOutput = "";
  titel = "";
  titelOutput = "";
  titelOutputMobile = "";
  titelLength = 0;
  getPercentLengthTitle = 0;
  metaDescription = "";
  metaDescriptionOutput = "";
  metaDescriptionOutputMobile = "";
  metaDescriptionLength = 0;
  getPercentLengthMetaDescription = 0;
  errorMessage = "";
  stylesTitle = {
    width: "0%",
    "background-color": "#1269D3",
  };
  stylesMetaDescription = {
    width: "0%",
    "background-color": "#1269D3",
  };
  isLoading = false;
  additionalRichSnippet = false;
  metaIcons = [
    { icon: "&#x25B6" },
    { icon: "&#x25C0" },
    { icon: "&#x25B2" },
    { icon: "&#x25BC" },
    { icon: "&#10003" },
    { icon: "&#x2705" },
    { icon: "&#x2718" },
    { icon: "&#x271A" },
    { icon: "&#x2606" },
    { icon: "&#x2605" },
    { icon: "&#x272A" },
    { icon: "&#x2665" },
    { icon: "&#x260E" },
    { icon: "&#x2708" },
    { icon: "&#x2709" },
    { icon: "&#x2600" },
    { icon: "&#x2602" },
  ];
  textPosition = 0;
  textTarget = "";
  faviconImage = "";

  loadUrl() {
    this.isLoading = true;
    var prefix = "http://";
    var prefixHttps = "https://";
    let submitUrl = this.url;
    if (
      this.url.substr(0, prefix.length) !== prefix &&
      this.url.substr(0, prefixHttps.length) !== prefixHttps
    ) {
      submitUrl = prefix + this.url;
    }
    this.faviconImage = "http://www.google.com/s2/favicons?domain="+submitUrl+"";
    this.urlOutput = this.url.replace(/(^\w+:|^)\/\//, "");
    Vue.axios
      .post("https://www.ultrapixel.de/php/snippet-generator/", { url: submitUrl })
      .then((response) => {
        this.isLoading = false;
        if (response.data.title === false) {
          this.errorMessage =
            "Wir konnten die Inhalte der eingegebenen URL leider nicht laden. Vielleicht ist unser Crawler gesperrt? Du kannst das Tool aber trotzdem nutzen und den Titel und die Meta-Beschreibung selber unten in das Formular eingeben.";
        } else {
          this.errorMessage = "";
          if (response?.data?.title) this.titel = response?.data?.title;
          this.getWidthTitle();
          if (response?.data?.description)
            this.metaDescription = response?.data?.description;
          this.getWidthMetaDescription();
        }
      });
  }

  selectInput(e: any, target: string) {
    this.textTarget = target;
    this.textPosition = e.target.selectionStart;
  }

  changeIcon(e: any) {
    if (this.textTarget === "titel")
      this.titel =
        this.titel.substring(0, this.textPosition) +
        e.target.value +
        this.titel.substring(this.textPosition);
    this.getWidthTitle();
    if (this.textTarget === "textarea")
      this.metaDescription =
        this.metaDescription.substring(0, this.textPosition) +
        e.target.value +
        this.metaDescription.substring(this.textPosition);
    this.getWidthMetaDescription();
  }

  checkTextLength(string: any, length: number, fontSize: number) {
    const chars = [...string];
    let returnText = "";
    let checkToLong = false;
    chars.forEach((element: string) => {
      let text = document.createElement("span");
      document.body.appendChild(text);
      text.style.font = "arial, sans-serif";
      text.style.fontSize = fontSize + "px";
      text.style.height = "auto";
      text.style.width = "auto";
      text.style.position = "absolute";
      text.style.whiteSpace = "no-wrap";
      text.innerHTML = returnText;
      let width = Math.ceil(text.clientWidth);
      text.innerHTML = returnText + element;
      let widthCheck = Math.ceil(text.clientWidth);
      document.body.removeChild(text);
      if (widthCheck <= length) {
        returnText = returnText + element;
      } else if (checkToLong === false) {
        checkToLong = true;
        returnText = returnText + "...";
      }
    });
    return returnText;
  }

  getURL() {
    this.urlOutput = this.url.replace(/(^\w+:|^)\/\//, "");
  }

  getWidthTitle() {
    let text = document.createElement("span");
    document.body.appendChild(text);
    text.style.font = "arial, sans-serif";
    text.style.fontSize = 20 + "px";
    text.style.height = "auto";
    text.style.width = "auto";
    text.style.position = "absolute";
    text.style.whiteSpace = "no-wrap";
    text.innerHTML = this.titel;
    let width = Math.ceil(text.clientWidth);
    document.body.removeChild(text);
    this.titelOutput = this.checkTextLength(this.titel, 580, 20);
    this.titelOutputMobile = this.checkTextLength(this.titel, 920, 20);
    this.titelLength = width;
    this.getPercentLengthTitle = (width / 580) * 100;
    if (this.getPercentLengthTitle < 80)
      this.stylesTitle["background-color"] = "#1269D3";
    if (this.getPercentLengthTitle >= 80 && this.getPercentLengthTitle < 100)
      this.stylesTitle["background-color"] = "#FFBF00";
    if (this.getPercentLengthTitle >= 100)
      this.stylesTitle["background-color"] = "#c02c02";
    this.stylesTitle.width = this.getPercentLengthTitle + "%";
  }

  getWidthMetaDescription() {
    let text = document.createElement("span");
    document.body.appendChild(text);
    text.style.font = "arial, sans-serif";
    text.style.fontSize = 14 + "px";
    text.style.height = "auto";
    text.style.width = "auto";
    text.style.position = "absolute";
    text.style.whiteSpace = "no-wrap";
    text.innerHTML = this.metaDescription;
    let width = Math.ceil(text.clientWidth);
    document.body.removeChild(text);
    this.metaDescriptionOutput = this.checkTextLength(
      this.metaDescription,
      990,
      14
    );
    this.metaDescriptionOutputMobile = this.checkTextLength(
      this.metaDescription,
      1300,
      14
    );
    this.metaDescriptionLength = width;
    this.getPercentLengthMetaDescription = (width / 990) * 100;
    if (this.getPercentLengthMetaDescription < 80)
      this.stylesMetaDescription["background-color"] = "#1269D3";
    if (
      this.getPercentLengthMetaDescription >= 80 &&
      this.getPercentLengthMetaDescription < 100
    )
      this.stylesMetaDescription["background-color"] = "#FFBF00";
    if (this.getPercentLengthMetaDescription >= 100)
      this.stylesMetaDescription["background-color"] = "#c02c02";
    this.stylesMetaDescription.width =
      this.getPercentLengthMetaDescription + "%";
  }
}
